import script from "./BrowsePicks.vue?vue&type=script&setup=true&lang=js"
export * from "./BrowsePicks.vue?vue&type=script&setup=true&lang=js"

import "./BrowsePicks.vue?vue&type=style&index=0&id=87bbef20&lang=scss"

const __exports__ = script;

export default __exports__